//@flow
function _get(...data:string[]):?any {
  try {
    let current = global && global.naturebox;
    data.forEach(datum => {
      current = current && current[datum];

      if (!current) return undefined;
    });
    return current;
  } catch (e) {
    return undefined;
  }
}

export default {
  get(...data:string[]):?any {
    return _get(...data);
  },

  getBool(...data:string[]):boolean {
    return !!_get(...data);
  },
};
